// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__-wWd4","tab":"Tabs_tab__xEL8e"};